export const ASSET_STOCKS_PAGE_MODULE_NAME = "assetStocksPage";
